import { useMutation } from "react-query";
import { gql } from "graphql-request";
import { IProgramFamily } from "@pbm/programs-families/contracts/program-family";
import { usePbm2Url } from "@common/hooks/usePbm2Url";

export function useCreateProgramFamily() {
  const { request } = usePbm2Url();
  return useMutation(async (variables: any) => {
    const { Rules_createProgramFamily } = await request(
      gql`
        mutation (
          $programCode: String!
          $input: Rules_CreateProgramFamilyInput!
        ) {
          Rules_createProgramFamily(programCode: $programCode, input: $input) {
            code
            name
            createdAt
            updatedAt
            deletedAt
            effectiveSince
            effectiveUntil
          }
        }
      `,
      {
        programCode: variables.programCode,
        input: {
          code: variables.code,
          name: variables.name,
          effectiveSince: variables.effectiveSince,
          effectiveUntil: variables.effectiveUntil,
        },
      }
    );
    return Rules_createProgramFamily as IProgramFamily;
  });
}
